import { render } from "./VerifyEmailPage.vue?vue&type=template&id=461772e6&scoped=true"
import script from "./VerifyEmailPage.vue?vue&type=script&lang=js"
export * from "./VerifyEmailPage.vue?vue&type=script&lang=js"

import "./VerifyEmailPage.vue?vue&type=style&index=0&id=461772e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461772e6"]])

export default __exports__